var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"focus-card",style:(_vm.cardStyle)},[_c('h4',{staticClass:"focus-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"focus-card__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }